import React from "react"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

import apple_icon_57x57 from '../../../../static/favicons/apple-icon-57x57.png';
import apple_icon_60x60 from '../../../../static/favicons/apple-icon-60x60.png';
import apple_icon_72x72 from '../../../../static/favicons/apple-icon-72x72.png';
import apple_icon_76x76 from '../../../../static/favicons/apple-icon-76x76.png';
import apple_icon_114x114 from '../../../../static/favicons/apple-icon-114x114.png';
import apple_icon_120x120 from '../../../../static/favicons/apple-icon-120x120.png';
import apple_icon_144x144 from '../../../../static/favicons/apple-icon-144x144.png';
import apple_icon_152x152 from '../../../../static/favicons/apple-icon-152x152.png';
import apple_icon_180x180 from '../../../../static/favicons/apple-icon-180x180.png';
import android_icon_192x192 from '../../../../static/favicons/android-icon-192x192.png';
import favicon_32x32 from '../../../../static/favicons/favicon-32x32.png';
import favicon_96x96 from '../../../../static/favicons/favicon-96x96.png';
import favicon_16x16 from '../../../../static/favicons/favicon-16x16.png';
import ms_icon_144x144 from '../../../../static/favicons/ms-icon-144x144.png';

function SEO({ description, lang, title, keywords, url }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            lang,
            siteUrl,
            keywords
          }
        }
      }
    `
  )

  const meta_description = description || site.siteMetadata.description
  const meta_lang = lang || site.siteMetadata.lang
  const meta_keywords = keywords || site.siteMetadata.keywords
  let meta_url = site.siteMetadata.siteUrl;
  if (url !== undefined) meta_url = site.siteMetadata.siteUrl+url

  return (
    <Helmet
      htmlAttributes={{
        meta_lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
    >
      <meta name="description" content={meta_description} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={meta_url+"/media/meta_icon.png"} />
      <meta property="og:url" content={meta_url} />
      <meta property="og:site_name" content='Лунная Керамика' />
      <meta property="og:description" content={meta_description} />
      <meta name="Keywords" content={meta_keywords} />
      <meta name="twitter:card" content='summary' />
      <meta name="twitter:creator" content={site.siteMetadata.author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={meta_description} />
      
      <link rel="apple-touch-icon" sizes="57x57" href={apple_icon_57x57} />
      <link rel="apple-touch-icon" sizes="60x60" href={apple_icon_60x60} />
      <link rel="apple-touch-icon" sizes="72x72" href={apple_icon_72x72} />
      <link rel="apple-touch-icon" sizes="76x76" href={apple_icon_76x76} />
      <link rel="apple-touch-icon" sizes="114x114" href={apple_icon_114x114} />
      <link rel="apple-touch-icon" sizes="120x120" href={apple_icon_120x120} />
      <link rel="apple-touch-icon" sizes="144x144" href={apple_icon_144x144} />
      <link rel="apple-touch-icon" sizes="152x152" href={apple_icon_152x152} />
      <link rel="apple-touch-icon" sizes="180x180" href={apple_icon_180x180} />
      <link rel="icon" type="image/png" sizes="192x192"  href={android_icon_192x192} />
      <link rel="icon" type="image/png" sizes="32x32" href={favicon_32x32} />
      <link rel="icon" type="image/png" sizes="96x96" href={favicon_96x96} />
      <link rel="icon" type="image/png" sizes="16x16" href={favicon_16x16} />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content={ms_icon_144x144} />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `ru`,
  meta: [],
  description: `Студия керамики в Минске`,
}

export default SEO